<!-- 由 suu 创建于 2022-06-22 Wednesday -->
<template>
  <div class="ques-contents">
    <div class="qc-list">
      <div
        class="l-item"
        :class="{ 'l-item-cur': active == index, 'l-item-ok': active > index }"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="dot-region">
          <van-icon
            name="checked"
            color="#9890FD"
            size="26"
            v-if="active > index"
          />
          <div class="i-dot" v-else></div>
        </div>
        <div class="i-title">{{ item.sub_title }}</div>
      </div>
      <div class="i-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-contents',

  components: {},

  props: {
    active: {},
    list: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-contents {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding-top: 168px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .qc-list {
    position: relative;
    z-index: 1;
    overflow: hidden;
    .l-item {
      height: 32px;
      display: flex;
      align-items: center;
      .dot-region {
        width: 32px;
        margin-right: 30px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f5f7;
        .i-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #697387;
        }
        .i-dot-cur {
          width: 26px;
          height: 26px;
          box-sizing: border-box;
          background: #ffffff;
          border: 3px solid #373d52;
        }
      }
      .i-title {
        font-size: 18px;
        font-weight: 600;
        color: #697387;
      }
    }
    .l-item + .l-item {
      margin-top: 22px;
    }
    .l-item-cur {
      .dot-region {
        .i-dot {
          width: 26px;
          height: 26px;
          background: #ffffff;
          border: 3px solid #373d52;
        }
      }
      .i-title {
        font-size: 24px;
        font-weight: 600;
        color: #373d52;
      }
    }
    .l-item-ok {
    }
    .i-line {
      width: 0;
      height: 86%;
      border-left: 1px dashed #c0c2d0;
      position: absolute;
      top: 12px;
      z-index: -1;
      left: calc(28px / 2);
      transform: translateX(100%);
    }
  }
}
</style>
